import { defineAction } from '~/prix'
import { z } from 'zod'
import communityGardenSeedlingDeleteAction from './communityGardenSeedlingDelete.action.json' with { type: 'json' }
import { communityGardenSeedlingObject } from '../../communityGardenSeedlingObject'

const communityGardenSeedlingDeleteDefinition = defineAction({
  ...communityGardenSeedlingDeleteAction,

  input: z.object({ id: communityGardenSeedlingObject.shape.id }),
  output: z.object({}),
})

export default communityGardenSeedlingDeleteDefinition
